// extracted by mini-css-extract-plugin
export default {"localeButton":"_1YWyMnGS8AXm3DY+zbfy7A==","localeButton--selected":"AUePS7V6D0ZZMp0xktTw1Q==","localeButton__popoverItem":"QDvUDFlJOe8sBe5e0vtbUw=="};